import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../jrni/login.service';

@Injectable({
  providedIn: 'root',
})
export class AccountGuardService {
  constructor(private router: Router, private loginService: LoginService) {}

  canActivate() {
    if (this.loginService.isLoggedIn()) {
      return true;
    }
    this.router.navigate(['/account-login']);
    return false;
  }
}
